const TEMPLATE_BLOCK_CATEGORY = {
  DATA_BOUND: "data_bound",
  CONTENT: "content",
  SIGNATURE: "signature",
  APPENDIX: "appendix",
  LAYOUT: "layout"
} as const

type TemplateBlockCategory =
  (typeof TEMPLATE_BLOCK_CATEGORY)[keyof typeof TEMPLATE_BLOCK_CATEGORY]

const TEMPLATE_BLOCK_CATEGORY_LABEL: Record<TemplateBlockCategory, string> = {
  [TEMPLATE_BLOCK_CATEGORY.DATA_BOUND]: "Data Bound",
  [TEMPLATE_BLOCK_CATEGORY.CONTENT]: "Content",
  [TEMPLATE_BLOCK_CATEGORY.SIGNATURE]: "Signature",
  [TEMPLATE_BLOCK_CATEGORY.APPENDIX]: "Appendix",
  [TEMPLATE_BLOCK_CATEGORY.LAYOUT]: "Layout"
}

export {
  TEMPLATE_BLOCK_CATEGORY,
  TEMPLATE_BLOCK_CATEGORY_LABEL,
  type TemplateBlockCategory
}
